export default __webpack_public_path__ + "static/media/demo.0b86897f.mov";